import { actions } from '.';

export const getBranchesV2Succeed = payload => ({
  type: actions.GET_BRANCHES_V2_SUCCEED,
  payload
});

export const getBranchesV2Failure = () => ({
  type: actions.GET_BRANCHES_V2_FAILURE
});

export const clearBranchesV2 = () => ({
  type: actions.CLEAR_BRANCHES_V2
});
